import {
  CART_UPSELLS,
  type CartUpsellFlowProps,
  getCartUpsellAnalyticsProps,
} from '../cartUpsells.registry'
import type { CartUpsellId } from '../cartUpsells.schemas'

export function CartUpsellFlow<Id extends CartUpsellId>({
  id,
  ...flowProps
}: Omit<CartUpsellFlowProps<Id>, 'analyticsProps'> & { id: Id }) {
  const Flow = CART_UPSELLS[id].Flow
  return (
    <Flow
      {...flowProps}
      analyticsProps={getCartUpsellAnalyticsProps(id, flowProps.offer)}
    />
  )
}
